import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ManufacturerWarrantyStatusBlockData from '../../../Models/Content/ManufacturerWarrantyStatusBlockData';
import ManufacturerWarrantyStatus from './ManufacturerWarrantyStatus';

export default class ManufacturerWarrantyStatusBlock extends EpiComponent<ManufacturerWarrantyStatusBlockData> {
    public render(): ReactNode | ReactNodeArray | null {

        return (
            <div className='manufacturer-warranty-status-block'>
                <ManufacturerWarrantyStatus iContent={this.props.data} context={this.getContext()} />
            </div>
        )
    }
}